export default __webpack_public_path__ + "static/media/gallery-wip-emitter_10.a6155176.jpg";